<script>
export default {
  components: {
  }
}
</script>
<template>
  <div class="no-sidebar">
    <div class="container">
      <slot />
    </div>
  </div>
</template>
<style scoped>
</style>
